import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import SubHeader from '../../components/SubHeader';
import AcSimpleTable from "../../components/AcSimpleTable";
import defaultValues from '../../constant/defaultValues';
import InputField from '../../components/InputField';
import { debounce, isEmpty, omit, size } from 'lodash';
import { ListOtp } from '../../actions/dictionaryAction';
import { connect } from 'react-redux';
import { convertUTCToTzDate, showSuccessMessage, showErrorMessage, downloadExcel, setAuthHeaders } from '../../utils/common';
import { hideLoading, showLoading } from '../../actions/loaderAction';
import ToolipsCustom from '../../components/ToolipsCustom';
import SmallPopup from "../../components/SmallPopup";
import { deleteOTP } from "../../actions/defaultDataAction";
import { ToastContainer } from "react-toastify";
import OtpFilter from '@/components/memberFilter/OtpFilter';
import Emitter from '@/utils/Emitter';
import ButtonAdd from '@/components/ButtonAdd';
import API_URL from '@/constant/api.config';
import axiosInstance from "@/axiosHttp";
import { useAuth } from '@/AuthProvider';

const OtpList = (props) => {

    const { admin } = defaultValues;
    const { isAdmin } = useAuth();
    const [otp, setOtp] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [columnName, setColumnName] = useState(admin.COLUMN_NAME);
    const [tableKey, setTableKey] = useState(0);
    const [limit, setLimit] = useState(admin.LIMIT);
    const [searchTxt, setSearchTxt] = useState("");
    const [totalRows, settotalRows] = useState(0);
    const [offset, setOffset] = useState(admin.OFFSET);
    const [sortDirection, setSortDirection] = useState(admin.SORT_DIRECTION);
    const [current_page, setCurrentPage] = useState(1);
    const [nodata, setNoData] = useState(false);

    const [deleteId, setDeleteId] = useState();
    const [smallmodalShow, setSmallModalShow] = useState(false);
    const [filterObj, setFilterObj] = useState(null);

    const initialRef = useRef(false);

    const handleDeleteClick = (id) => {
        setSmallModalShow(true);
        setDeleteId(id);
    };

    const handleConfirmDeleteClick = () => {
        props
            .deleteOTP(deleteId)
            .then((response) => {
                if (response.status === true) {
                    showSuccessMessage("OTP Deleted Successfully");
                    setOffset(admin.OFFSET);
                    setLimit(admin.LIMIT);
                    setColumnName(admin.COLUMN_NAME);
                    setSortDirection(admin.SORT_DIRECTION);
                    setSearchTxt("");
                    getOtp(admin.OFFSET, admin.LIMIT, current_page, admin.COLUMN_NAME, admin.SORT_DIRECTION, "");
                    // filterOTPList();
                    setTableKey((prev) => prev + 1);
                }
                setSmallModalShow(false);
            })
            .catch((err) => {
                console.log("Error == ", err);
                showErrorMessage("Something Went Wrong!!");
            });
    };




    const columns = [

        {
            name: 'Sr. No.',
            selector: row => <div className='text-wrap'>{row.id}</div>,
            width: "110px",
            columnName: 'id',
            sortable: true
        },
        {
            name: 'Name',
            selector: row => <div className='text-wrap'>{row.first_name ? row.first_name : ""} {row.last_name ? row.last_name : ""}</div>,
            width: "300px",
            columnName: 'name',
            sortable: false
        },
        {
            name: 'Email',
            selector: row => <div className='text-wrap'>{row.email ? row.email : ""}</div>,
            width: "300px",
            columnName: 'email',
            sortable: true
        },
        {
            name: 'Company Name',
            selector: row => <div className='text-wrap'>{row.company_name ? row.company_name : "-"}</div>,
            width: "300px",
            columnName: 'company_name',
            sortable: true
        },
        {
            name: 'Trade Mode',
            selector: row => <div className='text-wrap'>{row.trade_mode ? row.trade_mode : "-"}</div>,
            // width: "12%",
            columnName: 'trade_mode',
            sortable: true
        },
        {
            name: 'OTP No',
            selector: row => <div className='text-wrap'>{row.otp}</div>,
            // width: "12%",
            columnName: 'otp',
            sortable: true
        },
        {
            name: 'Registration Date',
            selector: row => <div className='text-wrap'>{convertUTCToTzDate(row.created_at)}</div>,
            width: "250px",
            columnName: "created_at",
            sortable: false
        },
        {
            name: 'Country',
            selector: (row) => {
                return (<div className='text-wrap'>{row.country ? row.country.name : "-"}</div>)
            },
            // width: "10%",
            columnName: "country_name",
            sortable: true
        },
        {
            name: 'City',
            selector: (row) => {
                return (<div className='text-wrap'>{row.city ? row.city.name : "-"}</div>)
            },
            columnName: "city",
            sortable: false
        },
        {
            name: 'website',
            selector: (row) => {
                return (<div className='text-wrap'>{row.website ? row.website : "-"}</div>)
            },
            width: "300px",
            columnName: "website",
            sortable: false
        },

        {
            omit: isAdmin,
            name: 'Actions',
            cell: (row) => (
                // !isAdmin &&
                <>
                    <ToolipsCustom
                        subtitle="Delete"
                        className="fa-solid fa-trash-can icon-trash border-0 "
                        classNameChild={"data-table-tooltiop"}
                        onClick={() => handleDeleteClick(row.id)}
                    ></ToolipsCustom>

                </>
            ),
            width: '100px'
        }];

    const onSearchTextBoxChanged = debounce(async (e) => {
        let searchVal = e.target.value;
        if (searchVal.length >= 3 || searchVal.length == 0) {
            setOffset(admin.OFFSET);
            setLimit(admin.LIMIT);
            setColumnName(admin.COLUMN_NAME);
            setSortDirection(admin.SORT_DIRECTION);
            setSearchTxt(e.target.value);
            setTableKey((prev) => prev + 1);
            await getOtp(admin.OFFSET, admin.LIMIT, current_page, admin.COLUMN_NAME, admin.SORT_DIRECTION, e.target.value);
        }
    });

    const handleSort = async (column, sortDirection) => {
        setColumnName(column.columnName);
        setSortDirection(sortDirection);
        getOtp(
            offset,
            limit,
            current_page,
            column.columnName,
            sortDirection,
            searchTxt
        );
    };

    const handleExport = () => {
        const headers = setAuthHeaders();
        let reqData = {
            trade_mode: filterObj != null ? filterObj.trade_mode : [],
            register_dates: filterObj != null ? filterObj.register_dates : []
        }
        axiosInstance
            .post(API_URL + "/export-otp-list",  reqData, { headers })
            .then((response) => {

                var data = response.data.data;
                var headers = response.data.headers;
                if(!isEmpty(data)) {
                    const now = new Date();
                    const year = now.getFullYear();
                    const month = String(now.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
                    const day = String(now.getDate()).padStart(2, '0');
                    const hours = String(now.getHours()).padStart(2, '0');
                    const minutes = String(now.getMinutes()).padStart(2, '0');
                    const seconds = String(now.getSeconds()).padStart(2, '0');

                    const formattedDate = `${year}-${month}-${day}_${hours}_${minutes}_${seconds}`;
                
                    downloadExcel(headers, data, 'otp_list_' + formattedDate);
                } else {
                    showErrorMessage("Data not found");
                }
                
            }).catch((err) => {
                console.log("Error ==== ", err);
            });
    }

    const getOtp = async (ofst = 0, lmt = 10 , current_page = 1, columnName, sortDirection, searchTxt) => {
        setNoData(false);
        props.showLoading();

        let fObj = { ...filterObj };
        if (fObj !== undefined && fObj !== 0 && fObj !== null && fObj !== "") {
            fObj.offset = ofst;
            fObj.limit = lmt;
            fObj.columnName = columnName;
            fObj.sortDirection = sortDirection;
            fObj.table_search = searchTxt;
        }

        await props
            .ListOtp(fObj)
            .then((response) => {
                setOtp([]);
                if (size(response.data) === 0) {
                    setNoData(true);
                }

                setOtp(response.data);
                settotalRows(response.metadata.total);
                props.hideLoading();
            })
            .catch((err) => {
                console.log("Error ==== ", err);
                showErrorMessage("Something went wrong");
            });
    }

    const setOTPFilters = (newState) => {

        newState.table_search = "";
        setLimit(newState.limit);
        setOffset(newState.offset);
        setCurrentPage(newState.current_page);
        setFilterObj(newState);
        setTableKey((prev) => prev + 1);
    }

    const filterOTPList = () => {
        getOtp(offset, limit, current_page, columnName, sortDirection, searchTxt);
    }


    useEffect(() => {

        // getOtp(offset, limit, current_page, columnName, sortDirection, searchTxt);
        if(initialRef.current == false) {
            initialRef.current = true;
            filterOTPList();
        }        

        Emitter.on("FILTER_OTP_LIST", filterOTPList);
        Emitter.on("SET_OTP_FILTER", setOTPFilters);
        return () => {
            Emitter.off("FILTER_OTP_LIST", filterOTPList);
        };

    });

    return (
        <>
            <div className='data-table-main logistic-table'>
                <div className="AcSimpleTable">

                    <SubHeader layer1="OTP List" layer2="List" layer3=""
                        pageName="OTP List"
                        clickable={{
                            layer1: "",
                            layer2: "",
                            layer3: ""
                        }}
                    />
                    <div className='filter-section'>
                        <OtpFilter />
                    </div>
                    <div className='card1 otp-card'>
                        
                        <div className='table-header-name'>
                            <h5 className='table-text py-3'>List</h5>
                            <div className='d-flex justify-content-between align-items-center py-3'>
                                {(!isAdmin) &&
                                 <ButtonAdd className='export-btn ms-2' type="button" onClick={handleExport}>
                                    <i className="fa-solid fa-upload"></i> Export
                                </ButtonAdd>
                                }

                                <label className='mx-3'>Search</label>
                                <InputField
                                    type="text"
                                    id="filter-text-box"
                                    placeholder="Search..."
                                    className="w-25"
                                    onChange={onSearchTextBoxChanged}
                                    onKeyUp={onSearchTextBoxChanged}
                                ></InputField>
                                
                            </div>
                        </div>

                        <div className="table-wrapper">
                            <div className="table-container">
                                <AcSimpleTable
                                    key={tableKey}
                                    data={otp}
                                    title=""
                                    pagination={true}
                                    paginationPageSize={limit}
                                    columns={columns}
                                    progressPending={loading}
                                    paginationTotalRows={totalRows}
                                    fixedColumnsStart={admin.FIXED_COLUMNS_START}
                                    offset={offset}
                                    limit={limit}
                                    columnName={columnName}
                                    sortDirection={sortDirection}
                                    setLimit={setLimit}
                                    setOffset={setOffset}
                                    setColumnName={setColumnName}
                                    setSortDirection={setSortDirection}
                                    setLoading={setLoading}
                                    // noDataComponent={<NoData />}
                                    paginationPerPage={limit}
                                    paginationRowsPerPageOptions={admin.PAGINATE_RANGE}
                                    // className="company-table"
                                    striped
                                    sortServer
                                    onSort={handleSort}
                                    defaultSortAsc={false}
                                    current_page={current_page}
                                    setCurrentPage={setCurrentPage}
                                    noData={nodata}
                                    searchTxt={searchTxt}
                                    getData={getOtp}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <SmallPopup
                title="Delete OTP"
                smallmodalShow={smallmodalShow}
                setSmallModalShow={setSmallModalShow}
                onSubmit={handleConfirmDeleteClick}
                closeButtonLabel="Cancel"
                okButtonLabel="Delete"
            >
                <div className='row my-3'>
                    <div className="col-md-12 p-0">Are you sure you want to delete OTP?</div>
                </div>

            </SmallPopup>
            {/* <ToastContainer /> */}
        </>
    );
};

const mapStateToProps = (state) => {
    return {

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        ListOtp: (fObj) =>
            dispatch(ListOtp(fObj)),
        deleteOTP: (id) => dispatch(deleteOTP(id)),
        hideLoading: () => dispatch(hideLoading()),
        showLoading: () => dispatch(showLoading())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpList);